import { Formik } from 'formik'

import { AccountForm } from '../common/account-profile-form/account-form.component'
import { useEditAccount } from 'src/hooks'
import { accountProfileSchema } from 'src/common/validations'
import { generateFormState } from '../common/account-profile-form/form/state.form'
import { IAccountByIdRespDto, IAccountFormUpdate } from 'src/types'

interface IEditAccountFormProps {
  account: IAccountByIdRespDto
  locale: string
  handleLocale?: (locale: string) => void
  enableReinitialize: boolean
}

const EditAccountForm = ({
  account,
  locale,
  handleLocale,
  enableReinitialize,
}: IEditAccountFormProps) => {
  const { mutateAsync: editAccount, isLoading } = useEditAccount()
  const initialValues = generateFormState(account)
  const handleSubmit = async ({ owner_email, ...values }: IAccountFormUpdate) => {
    await editAccount({
      ...values,
      oldIcon: account?.image,
      oldMedia: account?.media,
      image_small: account.image_small,
      image_medium: account.image_medium,
      locale,
    })
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={accountProfileSchema}
        validateOnBlur={false}
        onSubmit={handleSubmit}
        enableReinitialize={enableReinitialize}
      >
        <AccountForm
          account={account}
          isLoading={isLoading}
          locale={locale}
          handleLocale={handleLocale}
        />
      </Formik>
    </>
  )
}

export { EditAccountForm }
